"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
(function() {
  if (!customElements.get("testimonials-section")) {
    class TestimonialsSection extends HTMLElement {
      constructor() {
        super();
        __publicField(this, "setupExternalNavigation", () => {
          if (!this.nextBtn || !this.prevBtn) return;
          this.nextBtn.addEventListener("click", () => {
            var _a;
            (_a = this.swiper) == null ? void 0 : _a.slideNext();
            this.updateNavigationButtons();
          });
          this.prevBtn.addEventListener("click", () => {
            var _a;
            (_a = this.swiper) == null ? void 0 : _a.slidePrev();
            this.updateNavigationButtons();
          });
        });
        __publicField(this, "updateNavigationButtons", () => {
          if (!this.swiper || !this.nextBtn || !this.prevBtn) return;
          if (this.swiper.isBeginning && !this.swiper.isEnd) {
            this.nextBtn.classList.remove("disabled");
            this.prevBtn.classList.add("disabled");
          } else if (this.swiper.isEnd && !this.swiper.isBeginning) {
            this.prevBtn.classList.remove("disabled");
            this.nextBtn.classList.add("disabled");
          } else if (this.swiper.isEnd && this.swiper.isBeginning) {
            this.prevBtn.classList.add("disabled");
            this.nextBtn.classList.add("disabled");
          } else {
            this.prevBtn.classList.remove("disabled");
            this.nextBtn.classList.remove("disabled");
          }
        });
        __publicField(this, "initSwiper", () => {
          this.slider = this.querySelector(".swiper");
          if (!this.slider) return;
          let { autoplay, speed, changeSpeed, spaceBetween = 16, spaceBetweenPc = 16 } = this.dataset;
          const speedNum = Number(speed);
          const slideSpeed = Number.isFinite(speedNum) && speedNum > 0 ? speedNum : 400;
          const spaceMb = Number(spaceBetween) || 16;
          const spacePc = Number(spaceBetweenPc) || 16;
          const nextEl = this.querySelector(".title-wrapper .swiper-button-next");
          const prevEl = this.querySelector(".title-wrapper .swiper-button-prev");
          const swiperParams = {
            speed: slideSpeed,
            slidesPerView: "auto",
            scrollbar: true,
            spaceBetween: spaceMb,
            scrollbar: {
              el: ".swiper-scrollbar"
            },
            navigation: nextEl && prevEl ? { nextEl, prevEl } : void 0,
            breakpoints: {
              750: {
                spaceBetween: spacePc
              }
            }
          };
          if (autoplay == "true") {
            swiperParams.autoplay = {
              delay: Number(changeSpeed) || 4e3
            };
          }
          this.swiper = new Swiper(this.slider, __spreadProps(__spreadValues({}, swiperParams), {
            on: {
              slideChange: this.updateNavigationButtons,
              init: this.updateNavigationButtons,
              autoplay: () => {
                this.updateNavigationButtons();
              }
            }
          }));
        });
        this.swiper = null;
        this.nextBtn = null;
        this.prevBtn = null;
      }
      connectedCallback() {
        this.nextBtn = this.querySelector(".one-slide-per-page.swiper-button-next") || this.querySelector(".title-wrapper .swiper-button-next");
        this.prevBtn = this.querySelector(".one-slide-per-page.swiper-button-prev") || this.querySelector(".title-wrapper .swiper-button-prev");
        this.initSwiper();
        this.setupExternalNavigation();
        this.updateNavigationButtons();
      }
    }
    TestimonialsSection.prototype.swiperParams = {};
    customElements.define("testimonials-section", TestimonialsSection);
  }
})();
